var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconEye = function SvgIconEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m0-3.333A2.336 2.336 0 0 0 5.667 8 2.336 2.336 0 0 0 8 10.333 2.336 2.336 0 0 0 10.333 8 2.336 2.336 0 0 0 8 5.667m.146 5.665c-2.87.066-4.743-2.389-5.364-3.335.684-1.07 2.406-3.26 5.072-3.329 2.86-.072 4.742 2.39 5.364 3.335-.684 1.07-2.407 3.26-5.072 3.329m6.432-3.664c-.425-.74-2.774-4.457-6.758-4.332-3.686.093-5.829 3.34-6.398 4.332a.666.666 0 0 0 0 .664c.42.731 2.686 4.334 6.594 4.334.055 0 .11 0 .164-.002 3.685-.094 5.83-3.34 6.398-4.332a.669.669 0 0 0 0-.664",
    fill: "#636363",
    fillRule: "nonzero"
  })));
};

export default SvgIconEye;